
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ReceiptDialog extends _Ext.DialogBase<ReceiptRow, any> {
        protected getFormKey() { return ReceiptForm.formKey; }
        protected getIdProperty() { return ReceiptRow.idProperty; }
        protected getLocalTextPrefix() { return ReceiptRow.localTextPrefix; }
        protected getNameProperty() { return ReceiptRow.nameProperty; }
        protected getService() { return ReceiptService.baseUrl; }
        protected getDeletePermission() { return ReceiptRow.deletePermission; }
        protected getInsertPermission() { return ReceiptRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptRow.updatePermission; }
        protected useViewMode() { return true; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        } 
        public form = new ReceiptForm(this.idPrefix); 
        constructor() {
            super();

            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initDetailEditor(this, this.form.Details, Config);
            q.initDetailEditor(this, this.form.PartyBalance, Config);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategorySixColumn(this.form.CurrencyId);
            q.SetCategorySixColumn(this.form.Details);
            q.SetCategorySixColumn(this.form.PartyBalance);
            q.SetCategoryEightColumn(this.form.VoucherTypeId);
            q.SetCategoryFourColumn(this.form.KnockOffTotal);
            q.SetCategoryFullWidth(this.form.Narration);
            q.setTextRightAlign(this.form.CurrencyId);
            q.setTextRightAlign(this.form.ExchangeRate);
            q.setTextRightAlign(this.form.TotalAmount);
            q.setTextRightAlign(this.form.KnockOffTotal);
            q.hideCategorylinks(this.element);
            q.hideEditorLabel(this.form.Details);
            q.hideEditorLabel(this.form.PartyBalance);
            //Remove toolbar of PartyBalance Grid
            q.hideEditorToolbar(this.form.PartyBalance);
            q.hideEditorLabel(this.form.LedgerName);
            q.hideEditorCategoryLabel(this.form.TransDate.element);
            q.hideEditorCategoryLabel(this.form.CurrencyId.element);
            q.hideEditorCategoryLabel(this.form.VoucherTypeId.element);
            q.hideEditorCategoryLabel(this.form.KnockOffTotal.element);
            q.hideEditorCategoryLabel(this.form.Narration.element);

            this.form.LedgerId.changeSelect2(e => {

                var ledgerid = parseInt(this.form.LedgerId.value);
                //set Party Balance Grid based on Ledger Id
                this.form.PartyBalance.setPartyBalance(ledgerid);
                this.form.LedgerName.value = OMS.AccountLedgerRow.getLookup().itemById[ledgerid].LedgerName;

            });
            (this.form.Details.view as any).onRowCountChanged.subscribe(() => {
                if (this.form.Details.getItems().length > 0) {
                    q.showAndDisableField(this.form.LedgerId); 
                }
                this.calculateTotals();
            }); 

            (this.form.PartyBalance.view as any).onRowCountChanged.subscribe(() => {

                //calculate knock off value of the Knock Off Grid/Party Balance Grid
                this.calculateTotals();
                this.calculatePartyBalance();
            });
            this.form.KnockOffTotal.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.KnockOffTotal.value != this.form.TotalAmount.value) {
                    return "knock off values and total amount should match";
                }
            });
            this.validateForm();
        }
        calculateTotals() {
            var amt = 0;
            for (var k of this.form.Details.getItems()) {
                amt += k.Amount;
            }
            this.form.TotalAmount.value = amt; 
            if (this.form.Details.getItems().length > 0) {
                q.hideEditorToolbar(this.form.Details);
            }
        }

        calculatePartyBalance() {
            var ntamt = 0;
            var dueamt = 0;
            for (var x of this.form.PartyBalance.getItems()) {
                if (x.KnockOff != undefined) {
                    ntamt = ntamt + x.KnockOff;
                }
                dueamt = dueamt + x.Due;
            }
            this.form.KnockOffTotal.value = ntamt;
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.LedgerId.value == "") { 
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ExchangeRate.value = exchangerate[0].ExchRate;
            } 

            var fieldEditor: JQuery = this.form.LedgerId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                if (this.form.Details.getItems().length == 0) {
                    var grid = Common.PartySelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        AccountGroupId: 36
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Party", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.CustomerRow[]) => {

                        if (selectedItems.length > 0) {

                            this.form.LedgerId.value = selectedItems[0].LedgerId.toString();

                            this.form.PartyBalance.setPartyBalance(selectedItems[0].LedgerId);
                            this.form.LedgerName.value = selectedItems[0].LedgerName;
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();

            ////Edit Click Override
            //var btnEdit = Q.first(buttons , x => x.cssClass == "edit-button");
            //var oldEditClick = btnEdit.onClick;
            //btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };



            var btnDelete = Q.first(buttons, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Report Generation Button
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Finance.ReceiptVoucher',
                getParams: () => ({
                    TransId: this.get_entityId()
                })
            }));
            return buttons;
        } 


        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //if (this.canDelete) {
                ReceiptService.Delete(
                    {

                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                });
            //} else {
            //    Q.alert("Further Receipts for the Vouchers have been made, Cannot delete");
            //    return;
            //}

        }
    }




}
